// @vue/component

import ModalManager from '../../services/modalManager';

export default {
    methods: {
        openContactRequests() {
            return ModalManager.openModal('/calendar/contact-requests', undefined, undefined, 'full')
                .then(result => {
                    if (result?.action === 'create-appointment' && result.data.length) {
                        this.$store.commit('calendar/setCreateAppointmentContactRequestId', result.data[0].id);
                    }

                    return this.$store.dispatch('calendar/fetchContactRequestsCounter');
                });
        },
    },
};
